export default "__VITE_ASSET__B6ptft7L__"